import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import TripDetailsSection from "../TripDetailsSection";

export default function PODNumberDetails({
    label,
    options,
    podNumber,
    onChange,
    isEditable,
    pickupName,
}) {
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                options={options}
                selectedValue={podNumber}
                onSave={onChange}
                isEditable={isEditable}
                pickupName={pickupName}
            />
        </EuiFlexItem>
    );
}
